import { db } from '../firebase/firebaseConfig';
import { collection, addDoc, setDoc, getDoc, getDocs, updateDoc, doc, deleteDoc, onSnapshot, serverTimestamp, query, where  } from 'firebase/firestore';

// Neues Spiel hinzufügen
export const addGame = async (player1, player2, encounterId) => {
  try {
    await addDoc(collection(db, "games"), {
      player1,
      player2,
      encounterId,  
      sets: [
        { score1: 0, score2: 0 },
        { score1: 0, score2: 0 },
        { score1: 0, score2: 0 }
      ],
      status: "running",
      winner: null,
      createdAt: serverTimestamp()
    });
  } catch (error) {
    console.error("Fehler beim Hinzufügen des Spiels:", error);
  }
};

// Alle Spiele abrufen
export const getGames = async () => {
  const querySnapshot = await getDocs(collection(db, "games"));
  return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// Mannschaften abrufen
export const getTeams = async () => {
  const querySnapshot = await getDocs(collection(db, "teams"));
  return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};


// Begegnung hinzufügen
export const addEncounter = async (team1, team2, date) => {
  const docRef = await addDoc(collection(db, "encounters"), {
    team1,
    team2,
    date,
    games: [] // Spiele werden später hinzugefügt
  });
  return { id: docRef.id, team1, team2, date, games: [] };
};

// Alle Begegnungen abrufen
export const getEncounters = async () => {
  const querySnapshot = await getDocs(collection(db, "encounters"));
  return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// Echtzeit-Listener für Spiele nach Mannschaft
export const listenToGamesByEncounter = (encounterId, callback) => {
  const gamesCollection = collection(db, "games");

  const unsubscribe = onSnapshot(gamesCollection, (snapshot) => {
    let gamesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    if (encounterId !== "all") {
      gamesData = gamesData.filter(doc => doc.encounterId === encounterId);
    }

    callback(gamesData);
  });

  return unsubscribe;
};



// Funktion zum Hochzählen nach Tennisregeln
export const updateSetScore = async (gameId, setIndex, player, increment) => {
  const gameRef = doc(db, "games", gameId);
  const gameSnap = await getDoc(gameRef);

  if (gameSnap.exists()) {
    let gameData = gameSnap.data();

    if (increment) {
      gameData.sets[setIndex][`score${player}`]++;
    } else if (gameData.sets[setIndex][`score${player}`] > 0) {
      gameData.sets[setIndex][`score${player}`]--;
    }

    // Gewinner des Satzes ermitteln
    const score1 = gameData.sets[setIndex].score1;
    const score2 = gameData.sets[setIndex].score2;
    let winner = null;

    if (setIndex === 2) {
      // Tiebreak-Regeln: bis 10 Punkte mit 2 Punkten Vorsprung
      if ((score1 >= 10 || score2 >= 10) && Math.abs(score1 - score2) >= 2) {
        winner = score1 > score2 ? gameData.player1 : gameData.player2;
      }
    } else {
      // Normale Sätze: bis 6 Punkte mit 2 Punkten Vorsprung oder 7:6
      if ((score1 >= 6 && score1 - score2 >= 2) || score1 === 7) {
        winner = gameData.player1;
      } else if ((score2 >= 6 && score2 - score1 >= 2) || score2 === 7) {
        winner = gameData.player2;
      }
    }

    gameData.sets[setIndex].winner = winner;

    // Überprüfen, ob das Spiel beendet ist
    const setsWonByPlayer1 = gameData.sets.filter(set => set.winner === gameData.player1).length;
    const setsWonByPlayer2 = gameData.sets.filter(set => set.winner === gameData.player2).length;

    if (setsWonByPlayer1 === 2) {
      gameData.status = "finished";
      gameData.winner = gameData.player1;
    } else if (setsWonByPlayer2 === 2) {
      gameData.status = "finished";
      gameData.winner = gameData.player2;
    } else {
      gameData.status = "in_progress";
      gameData.winner = null;
    }

    await updateDoc(gameRef, gameData);
  }
};


// Spiel als beendet markieren
export const markGameAsFinished = async (gameId, winner) => {
  try {
    const gameRef = doc(db, "games", gameId);
    await updateDoc(gameRef, {
      status: "finished",
      winner: winner || "Unbekannt"
    });
  } catch (error) {
    console.error("Fehler beim Setzen des Gewinners:", error);
  }
};

// Spiel löschen
export const deleteGame = async (gameId) => {
  try {
    await deleteDoc(doc(db, "games", gameId));
  } catch (error) {
    console.error("Fehler beim Löschen des Spiels:", error);
  }
};
export const addTeam = async (teamName) => {
  const docRef = await addDoc(collection(db, "teams"), { name: teamName });
  return { id: docRef.id, name: teamName };
};

// Spiel zu einer Begegnung hinzufügen
export const addGameToEncounter = async (encounterId, gameId) => {
  const encounterRef = doc(db, "encounters", encounterId);
  const encounterSnapshot = await getDoc(encounterRef);
  const encounterData = encounterSnapshot.data();

  await updateDoc(encounterRef, {
    games: [...encounterData.games, gameId]
  });
};

//Begegnung löschen
export const deleteEncounter = async (encounterId) => {
  try {
    await deleteDoc(doc(db, "encounters", encounterId));
  } catch (error) {
    console.error("Fehler beim Löschen der Begegnung:", error);
  }
};

export const addReaction = async (gameId, userId, emoji) => {
  const gameRef = doc(db, "games", gameId);
  const reactionRef = doc(gameRef, "reactions", userId);

  try {
    // Überprüfen, ob der Nutzer bereits eine Reaktion gesetzt hat
    const existingReaction = await getDoc(reactionRef);

    if (existingReaction.exists()) {
      const oldReaction = existingReaction.data().emoji;
      
      // Falls die neue Reaktion gleich der alten ist, entferne sie stattdessen (Nutzer kann Reaktion zurücknehmen)
      if (oldReaction === emoji) {
        await setDoc(reactionRef, {}, { merge: true }); // Entfernt die Reaktion
        return "removed";
      }
    }

    // Neue Reaktion setzen oder alte überschreiben
    await setDoc(reactionRef, { emoji }, { merge: true });
    return "updated";
  } catch (error) {
    console.error("Fehler beim Speichern der Reaktion:", error);
  }
};

// Alle Reaktionen für ein Spiel abrufen
export const getReactions = async (gameId) => {
  const reactionsRef = collection(db, "games", gameId, "reactions");
  const snapshot = await getDocs(reactionsRef);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Nutzer zum Admin machen
export const makeAdmin = async (userId) => {
  try {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, { role: "admin" });
    console.log(`Nutzer ${userId} ist jetzt Admin.`);
  } catch (error) {
    console.error("Fehler beim Admin-Setzen:", error);
  }
};

export const saveSubscription = async (subscription) => {
  try {
    // Nur relevante Daten extrahieren
    const subscriptionData = JSON.parse(JSON.stringify(subscription));

    await addDoc(collection(db, "subscriptions"), subscriptionData);
    console.log("✅ Abonnement erfolgreich in Firestore gespeichert.");
  } catch (e) {
    console.error("❌ Fehler beim Speichern des Abonnements in Firestore:", e);
  }
};

const subscriptionsRef = collection(db, "subscriptions");

// 📌 **Prüfen, ob Nutzer bereits für Push angemeldet ist**
export const isUserSubscribed = async (uid) => {
  const q = query(subscriptionsRef, where("uid", "==", uid));
  const querySnapshot = await getDocs(q);
  return !querySnapshot.empty;
};
// 📌 **Nutzer für Push-Benachrichtigungen registrieren**
export const subscribeToPush = async (uid) => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: "BDjuKOBn9YZeX28aYtXJ2vXRpWpXBTv1w3NknRkwjKGujtENcMWDUfuHwGg_XNZUmhox6GUOXw1NNWzHyq6RCa8"
    });

    const subscriptionData = JSON.parse(JSON.stringify(subscription));
    subscriptionData.uid = uid; // Nutzer-ID hinzufügen

    await addDoc(subscriptionsRef, subscriptionData);
    console.log("✅ Nutzer für Push-Benachrichtigungen registriert:", uid);
    return true;
  } catch (e) {
    console.error("❌ Fehler beim Abonnieren:", e);
  }
};

// 📌 **Push-Subscription entfernen**
export const unsubscribeFromPush = async (uid) => {
  try {
    const q = query(subscriptionsRef, where("uid", "==", uid));
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach(async (doc) => {
      await deleteDoc(doc.ref);
    });

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
    }

    console.log("✅ Nutzer von Push-Benachrichtigungen abgemeldet:", uid);
  } catch (e) {
    console.error("❌ Fehler beim Abmelden:", e);
  }
};